import React from 'react';
import PopoverMenuItem from "../../../core/gd-components/popover-menu/popover-menu/menu-item";
import UserIcon from "../../../core/gd-components/icons/user/user";
import {QuickAddItemType} from "../../../app/quick-add/@types";
import PopoverMenuSeparator from "../../../core/gd-components/popover-menu/popover-menu/popover-menu-separator";

type Props = {
    hidePopover : callback
}

export default function MyAccountPopover(props: Props){

    const onClickChangeCompany = ()=>{
        gd.goTo('select-organization')
        props.hidePopover();
    }

    const onClickMyAccount = () => {
        gd.goTo('my-account');
        props.hidePopover();
    };

    const onClickSettings = () => {
        gd.goTo('settings');
        props.hidePopover();
    };

    const onClickInviteUser = ()=>{
        props.hidePopover();
        gd.openNew(QuickAddItemType.USER, {type: 'invite-user'})
    }

    const onClickUpgradeToPro = () => {
        props.hidePopover();
        gd.modals.other.upgradeToPro(gd.companyId)
    };

    const onClickHelp = () => {
        gd.goTo('app-help');
        props.hidePopover();
    };

    const onClickLogout = () => {
        gd.goTo('logout');
        props.hidePopover();
    };

    const canInviteUsers    = gd.ac.check.company.canInviteUsers()
    const isManager         = gd.ac.check.company.isManager()
    const isProLicense      = gd.company.license.isPro


    return (
        <>
            <div className="flex-row-left-center h-60 p-h-20">
                <UserIcon size="32" userId={gd.user.id}/>
                <div className="m-l-10">
                    <div className="ui5-txt-default lh-14em max-w-150 txt-truncate">
                        {gd.user.name}
                    </div>
                    <div className="flex-row-left-center">
                        <div className="ui5-txt-not-important-small lh-14em max-w-150 txt-truncate">
                            {gd.company.name}
                        </div>
                        {/*<div className="i5-switch ui5-txt-link m-l-10" onClick={onClickChangeCompany}></div>*/}
                    </div>
                </div>

            </div>
            <div className="ui5-popover-menu p-t-0">

                <PopoverMenuSeparator />

                <PopoverMenuItem icon       = "i5-user"
                                 label      = "Account Settings"
                                 onClick    = {onClickMyAccount}/>

                {isManager && (
                    <PopoverMenuItem icon       = "i5-settings"
                                     label      = "Organization Settings"
                                     onClick    = {onClickSettings}/>
                )}

                <PopoverMenuSeparator />

                {!isProLicense && (
                    <>
                        <PopoverMenuItem icon       = "i5-upgrade ui5-txt-link"
                                         label      = "Upgrade Your Plan"
                                         isLink     = {true}
                                         onClick    = {onClickUpgradeToPro}/>

                        <PopoverMenuSeparator />
                    </>
                )}

                {canInviteUsers && (
                    <PopoverMenuItem icon       = "i5-user-add"
                                     label      = "Invite to GoodDay"
                                     onClick    = {onClickInviteUser}/>
                )}

                <PopoverMenuItem icon       = "i5-question-circle"
                                 label      = "Help Center"
                                 onClick    = {onClickHelp}/>


                <PopoverMenuSeparator />

                <PopoverMenuItem icon       = "i5-crm-account"
                                 label      = "Switch Organization"
                                 onClick    = {onClickChangeCompany}/>

                <PopoverMenuItem icon       = "i5-clock-in"
                                 label      = "Logout"
                                 onClick    = {onClickLogout}/>

            </div>
        </>
    );
}
